import React, { FC } from 'react';
import { SvgIcon, Icons } from '../SvgIcon';

type Props = {
  icon: Icons;
};

const PageTitleIconPrefix: FC<Props> = ({ icon }) => <SvgIcon large icon={icon} />;

export default PageTitleIconPrefix;
